import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { SchemaDesignerLogicService, SchemaChangeLogicService } from '@tigergraph/tools-models/services';
import {
  useLoadingJobsHistory,
  useSchemaChangeLogicService,
  useSchemaDesignerLogicService,
} from '@/components/schemaDesigner/hooks/useSchemaHooks';
import { History, LoadingJobData } from '@tigergraph/tools-models';

interface SchemaDesignerContextValue {
  designerService: SchemaDesignerLogicService;
  changeService: SchemaChangeLogicService;
  loadingJobsHistory: History<{ [key: string]: LoadingJobData }>;
}

const schemaDesignerContext = createContext<SchemaDesignerContextValue>({} as SchemaDesignerContextValue);

const useSchemaDesignerContext = () => {
  const context = useContext(schemaDesignerContext);

  return {
    ...context,
  };
};

const SchemaDesignerProvider: FC<PropsWithChildren> = (props) => {
  const SchemaDesignerContextValue: SchemaDesignerContextValue = {
    designerService: useSchemaDesignerLogicService(),
    changeService: useSchemaChangeLogicService(),
    loadingJobsHistory: useLoadingJobsHistory(),
  };

  return <schemaDesignerContext.Provider value={SchemaDesignerContextValue} {...props} />;
};

export { SchemaDesignerProvider, useSchemaDesignerContext };
